import { WButton } from "@/components/button/WButton.tsx";
import { FieldButtonGroup } from "@/components/forms/FieldButtonGroup.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import type { VirtualMachineLoc } from "@/modules/compute/vmQuery.ts";
import { TargetServersSelect } from "@/modules/network/loadbalancer/TargetServersSelect.tsx";
import {
    addTargetToLoadBalancerMutation,
    type LoadBalancerWithType,
} from "@/modules/network/loadbalancer/loadBalancerApi.ts";
import { Trans } from "@lingui/react/macro";
import type { LbCreateTarget } from "@warrenio/api-spec/spec.oats.gen";
import { useState } from "react";

export interface AddTargetServerFormProps {
    item: LoadBalancerWithType;
    onClose: () => void;
}

export function AddTargetServerForm({ item, onClose }: AddTargetServerFormProps) {
    const { location, uuid, network_uuid } = item;

    const addTargetMutation = useStandardMutation(addTargetToLoadBalancerMutation);
    const [target, setTarget] = useState<LbCreateTarget>();

    async function onSubmit() {
        if (!target) {
            return;
        }
        await addTargetMutation.mutateAsync({
            location,
            uuid,
            body: target,
        });
        onClose();
    }

    function onChangeTarget(vm: VirtualMachineLoc) {
        setTarget({ target_type: "vm", target_uuid: vm.uuid });
    }

    return (
        <FieldButtonGroup>
            <TargetServersSelect
                defaultOpen={true}
                location={location}
                networkUuid={network_uuid}
                usedResourceUuids={item.targets.map((a) => a.target_uuid)}
                onChange={onChangeTarget}
            />
            <WButton color="primary" icon="jp-icon-add" action={onSubmit}>
                <Trans>Add</Trans>
            </WButton>
            <WButton action={onClose}>
                <Trans>Close</Trans>
            </WButton>
        </FieldButtonGroup>
    );
}
